import { SVG_ENUM } from "enums";
import SVG from "shared/SVG";
import ContextMenu from "shared/ContextMenu";
import { InvestmentTransactionType } from "hooks/investments/GetInvestmentTransactionsHook";

export const TYPE_LABELS: Record<string, string> = {
  buy: "Zakup",
  sell: "Sprzedaż",
};

export const INTEREST_TYPE_LABELS: Record<string, string> = {
  fixed: "Stałe",
  variable: "Zmienne",
  periodically_fixed: "Okresowo-stałe",
};

export const formatDate = (dateStr: string | null | undefined): string => {
  if (!dateStr) return "Brak";
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return "Brak";
  return d.toLocaleDateString("pl-PL", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

export const formatNumber = (value: number | undefined | null): string => {
  if (value === null || value === undefined) return "Brak";
  const num = Number(value);
  return num
    .toLocaleString("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    })
    .replace(/,/g, "\u00A0");
};

export const FileCell = ({ tx }: { tx: InvestmentTransactionType }) =>
  tx.file?.url ? (
    <a
      href={tx.file.url}
      target="_blank"
      rel="noreferrer"
      className="itm-table__file-link"
      title={tx.file.name ?? "Pobierz umowę"}
    >
      <SVG type={SVG_ENUM.FILE} />
    </a>
  ) : (
    <>{"Brak"}</>
  );

export const DotsMenu = ({
  tx,
  onEdit,
}: {
  tx: InvestmentTransactionType;
  onEdit?: () => void;
}) => {
  const items: {
    name: string;
    svg: SVG_ENUM;
    action: (data: any) => void;
  }[] = [];

  if (onEdit) {
    items.push({ name: "Edytuj", svg: SVG_ENUM.EDIT, action: () => onEdit() });
  }

  if (tx.file?.url) {
    items.push({
      name: "Pobierz",
      svg: SVG_ENUM.FILE_DOWNLOAD,
      action: () => {
        const link = document.createElement("a");
        link.href = tx.file!.url!;
        link.download = tx.file?.name ?? "plik";
        link.target = "_blank";
        link.rel = "noreferrer";
        link.click();
      },
    });
  }

  return (
    <ContextMenu data={tx} items={items}>
      <SVG type={SVG_ENUM.DOTS} />
    </ContextMenu>
  );
};

export const MobileActions = ({
  tx,
  onEdit,
}: {
  tx: InvestmentTransactionType;
  onEdit?: () => void;
}) => (
  <div className="itm-mobile-card__actions">
    {tx.file?.url && (
      <span
        className="itm-mobile-card__action-btn"
        onClick={() => {
          const link = document.createElement("a");
          link.href = tx.file!.url!;
          link.download = tx.file?.name ?? "plik";
          link.target = "_blank";
          link.rel = "noreferrer";
          link.click();
        }}
      >
        <SVG type={SVG_ENUM.FILE} />
      </span>
    )}
    {onEdit && (
      <span className="itm-mobile-card__action-btn" onClick={onEdit}>
        <SVG type={SVG_ENUM.EDIT} />
      </span>
    )}
  </div>
);
